module.exports = __webpack_public_path__ + "img/font.e3d9b1fb.svg";